import 'styled-components/macro';
import { gql } from '@apollo/client';
import * as React from 'react';
import styled from 'styled-components';

import { EmptyLabPlaceholder } from 'play/molecules/placeholders/empty-lab-placeholder/EmptyLabPlaceholder';
import { ChallengeTabType, ChallengeType, TabContentChallengeTabFragment } from 'types/graphql';

import { TabContentChallenge } from './TabContentChallenge';
import { TabContentQuiz } from './TabContentQuiz';

gql`
  fragment TabContentChallengeTab on ChallengeTab {
    id
    ...TabContentChallengeChallengeTab
  }
`;

export interface TabContentProps {
  isPreview?: boolean;
  tabs: TabContentChallengeTabFragment[];
  activeTabId?: string;
  answers: string[];
  challengeType: ChallengeType;
  captureFocusOnServiceTabs?: boolean;
  isResizing?: boolean;
  useNewTerminal?: boolean;
  isRefreshing?: boolean;
  onQuizAnswerChange(e: React.ChangeEvent<HTMLInputElement>, index: number): void;
}

export const TabContent = ({
  isPreview,
  tabs,
  activeTabId,
  answers,
  challengeType,
  captureFocusOnServiceTabs = false,
  isResizing = false,
  useNewTerminal = false,
  isRefreshing = false,
  onQuizAnswerChange,
}: TabContentProps) => {
  if (isPreview && !tabs.length) {
    return <EmptyLabPlaceholder />;
  }

  return (
    <Wrapper type={challengeType}>
      {challengeType === ChallengeType.Challenge ? (
        tabs.map(tab => {
          const isActive = tab.id === activeTabId;

          if (tab.type === ChallengeTabType.Terminal && useNewTerminal && isActive && isRefreshing) {
            return null;
          }

          return (
            <TabContentChallenge
              isPreview={isPreview}
              key={tab.id}
              tab={tab}
              active={isActive}
              captureFocusOnServiceTabs={captureFocusOnServiceTabs}
              isResizing={isResizing}
              useNewTerminal={useNewTerminal}
            />
          );
        })
      ) : (
        <TabContentQuiz answers={answers} onQuizAnswerChange={onQuizAnswerChange} />
      )}
    </Wrapper>
  );
};

interface WrapperProps {
  type: ChallengeType;
}

const Wrapper = styled.div<WrapperProps>`
  flex: 1;
  overflow: hidden;
  display: flex;
  position: relative;

  ${props =>
    props.type === ChallengeType.Quiz &&
    `
  justify-content: center;
  align-items: center;
  `};
`;
